<template>
  <div ref="chart" class="tabs" v-show="position.show">
    <div :style="{ width: `${position.w}px`, height: `${position.y}px`, paddingTop: '5px' }">
      <div :style="{ height: `${option.height}px`, display: 'flex', alignItems: 'center', padding: '5px' }">
        <span :style="{ color: `${option.btColor}`, fontSize: `${option.btFontSize}px` }">地区：</span>
        <a-tree-select
          v-model="option.treeValue"
          @change="changePlace"
          style="flex: 1"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="option.treeList"
          placeholder="请选择地区"
          tree-default-expand-all
          :style="
            `--my-color: ${option.color};--my-size: ${option.fontSize}px;--my-background: ${option.backgroundColor};`
          "
        >
        </a-tree-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 导航配置组件
  name: 'PlacePicker',
  components: {},
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
    // viewType: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {}
  },
  filters: {},
  computed: {},
  methods: {
    changePlace() {
      this.$emit('changePlace', this.option.treeValue)
    }
  }
}
</script>

<style scoped lang="less">
.tabs {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.tab-header {
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
}
::v-deep .ant-select {
  color: var(--my-color);
  font-size: var(--my-size);
}
::v-deep .ant-select-selection {
  background: var(--my-background);
}
// .picker {
//   color: var(--my-color) !important;
//   ::v-deep .ant-input {
//     color: var(--my-color) !important;
//   }
//   /* 注意：Less 本身不支持 CSS 变量，但你可以使用 CSS 片段或混合（mixin）来间接使用 */
// }
</style>
